import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { QuickComment } from '../models/quick-comment.model';

const API_BASE = environment.TIMELINE_BASE;

@Injectable()
export class QuickCommentsService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getQuickComments(task_template_id: number) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/task_template_quick_comment/task_template/${task_template_id}`,
    );
  }

  updateQuickComment(body, task_template_id): Observable<QuickComment[]> {
    return this.http.put<any>(
      `${API_BASE}/companies/${this.companyId}/task_template_quick_comment/task_template/${task_template_id}`,
      body,
    );
  }
}
